import * as React from 'react';
import { connect } from 'react-redux';

import ConceptSelector from './conceptSelector';

import  {ConceptExplanation, } from '../feedback/conceptExplanation'

interface ConceptSelectorWithCheckboxProps {
  handleSelectorChange: Function;
  currentConceptUID: string;
  selectorDisabled: boolean;
  checked: boolean;
  onCheckboxChange: Function;
  deleteConceptResult: Function;
  conceptsFeedback: any;
  concepts: any;
  fillInTheBlank?: boolean;
  hideConceptFeedback: boolean;
}

class ConceptSelectorWithCheckbox extends React.Component<ConceptSelectorWithCheckboxProps, {}> {

  currentConcept = () => {
    const { concepts, currentConceptUID } = this.props
    if (!concepts.data["0"]) { return }
    return concepts.data["0"].find(concept => concept.uid === currentConceptUID)
  }

  renderConceptFeedback = () => {
    const { currentConceptUID, conceptsFeedback } = this.props
    if (currentConceptUID && currentConceptUID.length > 0 && this.currentConcept() && conceptsFeedback?.data) {
      return (<ConceptExplanation {...conceptsFeedback.data[currentConceptUID]} />)
    }
  }

  render() {
    const { currentConceptUID, handleSelectorChange, selectorDisabled, checked, onCheckboxChange, deleteConceptResult, hideConceptFeedback, } = this.props
    return(
      <React.Fragment>
        <div style={{display: 'flex'}}>
          <div style={{flexGrow: 1}}>
            <ConceptSelector
              currentConceptUID={currentConceptUID}
              handleSelectorChange={handleSelectorChange}
              selectorDisabled={selectorDisabled}
            />
          </div>
          <label className="checkbox" style={{lineHeight: '32px', marginLeft: '5px'}}>
            <h3><input aria-label="Correct?" checked={checked} onClick={onCheckboxChange} type="checkbox" /> Correct?</h3>
          </label>

          <button aria-label="Delete concept result" className="interactive-wrapper focus-on-light" onClick={deleteConceptResult} style={{paddingLeft: '10px', paddingTop: '6px', cursor: 'pointer'}} type="button">X</button>
        </div>
        {hideConceptFeedback ? null : this.renderConceptFeedback()}
      </React.Fragment>
    )
  }
}

function select(state, ownProps) {
  return {
    concepts: state.concepts,
    conceptsFeedback: ownProps.fillInTheBlank ? state.fillInBlankConceptsFeedback : state.conceptsFeedback
  };
}

export default connect(select)(ConceptSelectorWithCheckbox);
